import React from 'react';

import { TooltipContainer } from './styles';

export default ({ children, light }) => {
  return <TooltipContainer light={light}>{children}</TooltipContainer>;
};
